import ChatbotLines from "src/utilities/ChatbotLines";
import Stroke from "src/utilities/Stroke";
import {
  depthBlockPadding,
  depthHeight,
  depthWidth,
  useTranslationController,
} from "../utils";

export default function FromPreviousStroke() {
  const controller = useTranslationController();

  const { heightToParent } = controller.useFileSelector((c, key) => {
    const containingElement = c.getContainingFile(key);
    const heightToParent = containingElement
      ? c.getCumulatedHeight(containingElement, key, true)
      : 0;
    return { heightToParent };
  }, []);

  return (
    <Stroke
      path={`M ${depthWidth / 2} ${depthBlockPadding} L ${depthWidth / 2}  ${
        heightToParent * -1 + depthHeight - depthBlockPadding
      }`}
      {...ChatbotLines.getTranslationStrokeProps()}
    />
  );
}
